import { jsx as _jsx } from "react/jsx-runtime";
import './index.less';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@router';
const root = createRoot(document.getElementById('root'));
root.render(_jsx(StrictMode, { children: _jsx(RouterProvider, { router: router }) }));
